import { Navigate, Outlet, useLocation, type RouteObject } from "react-router";
import {
  AuthCallbackScreen,
  LoadingState,
  LoginScreen,
  useAuthState,
} from "visumo-data-agent-web-shared";

import { AppShell } from "./AppShell";
import { AccountPage } from "./pages/AccountPage";
import { AuditPage } from "./pages/AuditPage";
import { ComparePage } from "./pages/ComparePage";
import { HelpPage } from "./pages/HelpPage";
import { SemanticsFillPage } from "./pages/SemanticsFillPage";
import { TenantsPage } from "./pages/TenantsPage";
import { ViewerProvider } from "./ViewerContext";

function AuthenticatedArea() {
  const state = useAuthState();
  const location = useLocation();
  if (state.status === "initializing" || state.status === "authorizing") {
    return <LoadingState label="ログイン状態を確かめています" />;
  }
  if (state.status !== "authenticated") {
    return (
      <Navigate
        to="/login"
        replace
        state={{ returnTo: `${location.pathname}${location.search}` }}
      />
    );
  }
  return (
    <ViewerProvider>
      <Outlet />
    </ViewerProvider>
  );
}

function OperatorLogin() {
  const state = useAuthState();
  if (state.status === "authenticated") {
    return <Navigate to="/" replace />;
  }
  return (
    <LoginScreen
      appName="visumo 管理画面(オペレーター)"
      description="visumo のアカウントでログインします。"
    />
  );
}

/** パス方式のルート定義。hash は使わない */
export const routes: RouteObject[] = [
  { path: "/login", element: <OperatorLogin /> },
  { path: "/auth/callback", element: <AuthCallbackScreen fallbackPath="/" /> },
  {
    element: <AuthenticatedArea />,
    children: [
      {
        path: "/",
        element: <AppShell />,
        children: [
          { index: true, element: <TenantsPage /> },
          { path: "compare", element: <ComparePage /> },
          { path: "semantics-fill", element: <SemanticsFillPage /> },
          { path: "audit", element: <AuditPage /> },
          { path: "account", element: <AccountPage /> },
          { path: "help", element: <HelpPage /> },
          { path: "help/*", element: <HelpPage /> },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
];
